import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ResetPassword from './pages/ResetPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DeleteAccount from './pages/DeleteAccount';
import DeleteAccountConfirm from './pages/DeleteAccountConfirm';
import DeleteAccountScheduled from './pages/DeleteAccountScheduled';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reset-pw" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsOfService />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/delete-account/confirm" element={<DeleteAccountConfirm />} />
          <Route path="/delete-account/scheduled" element={<DeleteAccountScheduled />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;